module.exports = __webpack_public_path__ + "media/recipes/152-5173dbbf.png";